import { Level } from '@/store/candidate.store';
import Colors from '@/theme/constants/Colors';
import { Typography } from '@mui/material';

interface stepLabelProps {
  stepLabel?: string;
  allsteps?: string[];
  step?: number;
  id?: number;
  isActive?: boolean;
  isPassed?: boolean;
  levels?: Level[];
}
function StepLabel(props: stepLabelProps) {
  const { stepLabel, allsteps, levels } = props;
  // #3AA05C #AA779F #662B5C

  const setStepColors = (level: Level) => {
    const { isActive, isPassed, id } = level;
    if (id === 1) {
      if (isActive) {
        return Colors.PRIMARY_ACCENT;
      } else if (isPassed) {
        return Colors.COLOR_TEXT_GREEN;
      }
    } else if (id === 2) {
      if (isActive) {
        return Colors.PRIMARY_ACCENT;
      }
      if (isPassed) {
        return Colors.COLOR_TEXT_GREEN;
      }
    } else if (id === 3) {
      if (isActive) {
        return Colors.PRIMARY_ACCENT;
      } else if (isPassed) {
        return Colors.COLOR_TEXT_GREEN;
      }
    }
  };

  return (
    <div
      style={{
        height: '40px',
        display: 'flex',
        alignItems: 'center',
        borderRadius: '88px',
        backgroundColor: Colors.COLOR_TEXT_BG,
        justifyContent: 'center',
        paddingInline: '16px',
      }}
    >
      {stepLabel && (
        <Typography
          sx={{
            fontFamily: 'Inter',
            fontSize: '16px',
            fontWeight: '700',
            lineHeight: '24px',
            letterSpacing: '0px',
            textAlign: 'right',
            color: Colors.COLOR_TEXT_MASK,
          }}
        >
          {stepLabel}
        </Typography>
      )}
      {allsteps && (
        <Typography
          sx={{
            fontFamily: 'Inter',
            fontSize: '16px',
            fontWeight: '700',
            lineHeight: '24px',
            letterSpacing: '0px',
            color: Colors.COLOR_TEXT_MASK,
          }}
        >
          {levels?.map((level, index) => {
            return (
              <span
                key={level.id}
                style={{
                  color: `${setStepColors(level)}`,
                  marginInline: '16px',
                }}
              >
                {`${allsteps[index]} (${level.timeRecord}s)`}
              </span>
            );
          })}
        </Typography>
      )}
    </div>
  );
}

export default StepLabel;
